export default {
  populate: function populate(item, model, address1, address2, suburb, state, postcode, lat, lng) {
    if (item.flat_number && item.flat_number !== '') {
      // eslint-disable-next-line
      if (item.flat_type) {
        model[address1] = item.flat_type;
      }

      model[address1] = model[address1] ? "".concat(model[address1], " ").concat(item.flat_number_prefix || '').concat(item.flat_number).concat(item.flat_number_suffix || '') : "".concat(item.flat_number_prefix || '').concat(item.flat_number).concat(item.flat_number_suffix || '');
    } else {
      // eslint-disable-next-line
      model[address1] = '';
    }

    if (item.number_first && item.number_first !== '') {
      // eslint-disable-next-line
      model[address2] = "".concat(item.number_first_prefix || '').concat(item.number_first).concat(item.number_first_suffix || '');

      if (item.number_last) {
        model[address2] += "-".concat(item.number_last_prefix || '').concat(item.number_last).concat(item.number_last_suffix || '');
      }
    } else {
      // eslint-disable-next-line
      model[address2] = '';
    }

    if (item.street_name && item.street_name !== '') {
      // eslint-disable-next-line
      model[address2] += ' ' + item.street_name;
    }

    if (item.street_type_code && item.street_type_code !== '') {
      // eslint-disable-next-line
      model[address2] += ' ' + item.street_type_code;
    }

    if (item.locality_name) {
      // eslint-disable-next-line
      model[suburb] = item.locality_name;
    } else {
      // eslint-disable-next-line
      model[suburb] = null;
    }

    if (item.state_abbreviation) {
      // eslint-disable-next-line
      model[state] = item.state_abbreviation;
    } else {
      // eslint-disable-next-line
      model[state] = null;
    }

    if (item.postcode) {
      // eslint-disable-next-line
      model[postcode] = item.postcode;
    } else {
      // eslint-disable-next-line
      model[postcode] = null;
    } // lat


    if (lat) {
      // eslint-disable-next-line
      model[lat] = item.latitude;
    } // lng


    if (lat) {
      // eslint-disable-next-line
      model[lng] = item.longitude;
    }
  },
  ausStates: function ausStates() {
    return [{
      name: 'ACT',
      value: 'ACT'
    }, {
      name: 'NSW',
      value: 'NSW'
    }, {
      name: 'NT',
      value: 'NT'
    }, {
      name: 'QLD',
      value: 'QLD'
    }, {
      name: 'SA',
      value: 'SA'
    }, {
      name: 'TAS',
      value: 'TAS'
    }, {
      name: 'VIC',
      value: 'VIC'
    }, {
      name: 'WA',
      value: 'WA'
    }];
  }
};